module.exports = __webpack_public_path__ + "static/p1-4760c9c8db9eb71bf6b3e6ac9cab1e71.jpg";